import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\WikiPlace\GetNewWikiPlaceController::__invoke
* @see app/Http/Controllers/WikiPlace/GetNewWikiPlaceController.php
* @route '/api/place/new'
*/
const GetNewWikiPlaceController = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetNewWikiPlaceController.url(options),
    method: 'get',
})

GetNewWikiPlaceController.definition = {
    methods: ["get","head"],
    url: '/api/place/new',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\WikiPlace\GetNewWikiPlaceController::__invoke
* @see app/Http/Controllers/WikiPlace/GetNewWikiPlaceController.php
* @route '/api/place/new'
*/
GetNewWikiPlaceController.url = (options?: RouteQueryOptions) => {
    return GetNewWikiPlaceController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\WikiPlace\GetNewWikiPlaceController::__invoke
* @see app/Http/Controllers/WikiPlace/GetNewWikiPlaceController.php
* @route '/api/place/new'
*/
GetNewWikiPlaceController.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetNewWikiPlaceController.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\WikiPlace\GetNewWikiPlaceController::__invoke
* @see app/Http/Controllers/WikiPlace/GetNewWikiPlaceController.php
* @route '/api/place/new'
*/
GetNewWikiPlaceController.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetNewWikiPlaceController.url(options),
    method: 'head',
})

export default GetNewWikiPlaceController